/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:36:37
 * @LastEditors: Gaho
 * @LastEditTime: 2023-12-29 14:43:02
 */
const s = {
    ballDistance: 24.2,
    diameter: 7.9,
    numRows: 11,
    yMult: 1.18,
    ballProp: {
        mass: 1.1,
        densety: .9,
        friction: {
            x: .97,
            y: .93
        }
    },
    xps: {
        0: [196.6906590174336, 197.46331471290713, 231.20641877091467, 230.8017321254389, 196.5658438291945, 196.69033526253335, 228.2443259128631, 231.1961772737426],
        1: [197.34733556520118, 197.40758030580585, 231.00493539950142, 230.27901565606726, 196.821516971676, 198.36452518776, 196.04169654550336, 197.56047089641464],
        2: [230.63420331566232, 198.65200562470224, 196.67661530365027, 198.370680697022, 197.33162610977104, 196.57052945898897, 228.16392584858195, 198.7921510743577],
        3: [197.98745950127858, 228.18649219089875, 199.0735364102161, 197.11707335381521, 231.33682701503133, 199.84554096014222, 197.524652170419, 197.3906289239156],
        4: [197.73635468107904, 231.48434325807733, 197.1535557710403, 196.77909775891635, 198.60220330778427, 196.62546736212698, 229.53618938040088, 197.9329122020576],
        5: [228.85235517967016, 230.47779618405895, 198.54109996453928, 230.8041733374177, 198.88232458390658, 198.60967624300298, 196.55657717366648, 197.25262320203188],
        6: [196.9214513346729, 197.70926774662374, 229.00710291653158, 229.56578193689998, 230.8299049483497, 230.65233291188545, 228.14624424709467, 199.7251460133864],
        7: [229.6456073208315, 198.76170285913616, 228.59413717171654, 196.7645600519162, 229.2095817429866, 199.74354000291305, 196.40622092743763, 198.6510275519726],
        8: [228.77287123760587, 230.80355488331662, 231.5657916162142, 198.49724477680812, 196.898095914235, 228.20098897747067, 229.35586079761543, 229.47188527877526],
        9: [197.19270699183824, 228.26856300939315, 197.42861065489095, 228.91642258452885, 229.24534335693474, 228.06655114358045, 197.04857700331308, 231.0897004756671],
        10: [228.85898991819082, 199.3322251529217, 197.69740876299895, 195.95589015650162, 197.41052979498127, 198.76925193605823, 196.77031847307995, 229.5234570989156],
        11: [228.70727232501432, 229.42565599972016, 229.15862385268295, 229.54145518660195, 229.28452125021906, 229.1640911909284, 230.59699925804344, 196.771893766455],
        12: []
    }
};
export {s as default};
